
(function () {
  var overlay = document.getElementById('lightboxOverlay');
  var overlayImg = document.getElementById('lightboxImg');
  var closeBtn = document.getElementById('lightboxClose');
  var counter = document.getElementById('lightboxCounter');
  var images = [];
  var currentIndex = 0;

  function collectImages() {
    images = Array.prototype.slice.call(document.querySelectorAll('.blog-scoped img.lightbox-img'));
  }

  function openLightbox(index) {
    if (!images.length) return;
    currentIndex = index;
    var img = images[currentIndex];
    overlayImg.src = img.getAttribute('data-full') || img.src;
    overlayImg.alt = img.alt || '';
    counter.textContent = (currentIndex + 1) + ' / ' + images.length;
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    overlay.classList.remove('active');
    overlayImg.src = '';
    document.body.style.overflow = '';
  }

  function showNext() { openLightbox((currentIndex + 1) % images.length); }
  function showPrev() { openLightbox((currentIndex - 1 + images.length) % images.length); }

  document.addEventListener('DOMContentLoaded', function () {
    collectImages();
    images.forEach(function (img, i) {
      img.addEventListener('click', function () { openLightbox(i); });
    });
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeLightbox();
  });
  closeBtn.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('active')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrev();
  });

  // simpele swipe/klik links-rechts binnen de vergrote foto om te bladeren
  overlayImg.addEventListener('click', function (e) {
    var half = overlayImg.clientWidth / 2;
    if (e.offsetX > half) { showNext(); } else { showPrev(); }
  });
})();
